import {Component, Inject, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import {locale as polish} from './i18n/pl';
import {FuseTranslationLoaderService} from "../../../../@fuse/services/translation-loader.service";

@Component({
    selector: 'new-note-dialog',
    templateUrl: './newNoteDialog.component.html',
    styleUrls: ['./newNoteDialog.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class NewNoteDialogComponent {
    action: string;
    noteForm: FormGroup;
    dialogTitle: string;
    customer?: string = null;
    resource?: string = null;

    constructor(
        public matDialogRef: MatDialogRef<NewNoteDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private _formBuilder: FormBuilder,
        private translationLoader: FuseTranslationLoaderService,
    ) {
        this.translationLoader.loadTranslations(polish);
        // Set the defaults
        this.action = _data.action;
        this.customer = _data.customer;
        this.resource = _data.resource;

        this.noteForm = this.createForm();
    }

    createForm(): FormGroup {
        return this._formBuilder.group({
            title: ['', Validators.required],
            description: ['', Validators.required],
            customer: [this.customer],
            resource: [this.resource],
        });
    }
}
